var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticClass:"h-8 w-8",attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24","fill":"none","stroke":"currentColor","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{attrs:{"d":"M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }